import { useState } from "react";
import api, { formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { LockKey, Eye, EyeSlash, SignOut } from "@phosphor-icons/react";

export default function LockScreen() {
  const { user, unlock, logout } = useAuth();
  const [password, setPassword] = useState("");
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await api.post("/auth/verify-password", { password });
      setPassword("");
      unlock();
    } catch (e2) {
      setError(formatApiErrorDetail(e2.response?.data?.detail) || "Incorrect password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="lock-screen-overlay"
      className="fixed inset-0 z-[9999] flex items-center justify-center bg-navy/95 backdrop-blur-md px-6">
      <div className="w-full max-w-sm fade-up text-center">
        <div className="mx-auto w-14 h-14 rounded-2xl bg-white/10 flex items-center justify-center mb-5">
          <LockKey size={28} weight="fill" className="text-white" style={{ color: "#F37A24" }} />
        </div>
        <div className="overline mb-2" style={{ color: "#F37A24" }}>Session locked</div>
        <h2 className="font-heading font-bold text-2xl tracking-tight text-white mb-1.5">
          Welcome back{user?.name ? `, ${user.name.split(" ")[0]}` : ""}
        </h2>
        <p className="text-white/60 text-sm mb-7">
          You were signed out for inactivity. Enter your password to continue.
        </p>

        <form onSubmit={submit} className="space-y-4 text-left">
          <div className="relative">
            <input data-testid="lock-password-input" type={show ? "text" : "password"} required autoFocus
              value={password} onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              className="w-full bg-white/[0.06] border border-white/15 rounded-xl px-4 py-3 pr-11 text-sm text-white placeholder:text-white/30 outline-none focus:border-[#F37A24] focus:ring-2 focus:ring-[#F37A24]/30 transition-colors" />
            <button type="button" onClick={() => setShow(!show)}
              className="absolute right-3 top-1/2 -translate-y-1/2 text-white/70 hover:text-white">
              {show ? <EyeSlash size={18} /> : <Eye size={18} />}
            </button>
          </div>

          {error && <div data-testid="lock-error" className="text-[#C2410C] text-sm font-medium">{error}</div>}

          <button type="submit" disabled={loading} data-testid="lock-unlock-btn"
            className="w-full text-white font-semibold py-3 rounded-xl transition-colors duration-200 disabled:opacity-60"
            style={{ background: "#F37A24" }}>
            {loading ? "CHECKING…" : "Unlock"}
          </button>
        </form>

        <button onClick={logout} data-testid="lock-signout-btn"
          className="mt-5 inline-flex items-center gap-2 text-white/70 hover:text-white text-sm transition-colors">
          <SignOut size={16} /> Sign out instead
        </button>
      </div>
    </div>
  );
}
